import { useHistory, useParams } from 'react-router';
import React, { useContext, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ModalItem from '../../common/ModalItem/ModalItem';
import './task-info.scss';
import { Container, Hidden } from '@material-ui/core';
import { Link, Route, Switch } from 'react-router-dom';
import TaskFinish from '../TaskFinish/TaskFinish';
import { connect } from 'react-redux';
import YellowButton from '../../common/YellowButton';
import { postSolution } from '../../../store/activitiesSlice';
import { changeErrorPopupState } from '../../../store/uiSlice';
import { completedRoutes } from '../../../common/constants';
import IsMobileContext from '../../../common/IsMobileContext';
import * as tasksActions from '../../../store/tasksSlice';
import CircularProgress from '@material-ui/core/CircularProgress';
import ScoreToRubblesInfo from '../../common/ScroreToRubbleInfo';
import { toNumber } from 'lodash';
import UndefinedTask from './UndefinedTask';
import BottomButton from '../../common/BottomButton';

const ContentSwitch = (props) => {
  const { desktopOption, content, taskId } = props;

  return (
    <Switch>
      <Route path={completedRoutes.taskFinish(taskId)}>
        <TaskFinish />
      </Route>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

function TaskInfo(props) {
  const history = useHistory();
  const params = useParams();
  const taskId = toNumber(params.taskId)
  const { t } = useTranslation();
  const isMobileDesign = useContext(IsMobileContext);
  const taskData = props.tasksById[taskId];

  const {
    isSolutionsFetching, getTaskSolutionsCountById, changeErrorPopupState, userPlacesById
  } = props;

  useEffect(() => {
    const fetchData = () => {
      getTaskSolutionsCountById(taskId)
        .catch((error) => {
          console.error(error);
          changeErrorPopupState({ type: 'default', isOpen: true, error });
        });
    };
    if (taskId !== null && taskData !== undefined) {
      fetchData();
    }
  }, [getTaskSolutionsCountById, taskId, changeErrorPopupState, taskData]);

  if (taskId === null) return null;

  if (taskData === undefined) {
    return props.isTasksFetched ? <UndefinedTask/> : null;
  }

  const handleDo = () => {
    props.postSolution(taskId)
      .then((res) => {
        const { id: solutionId, state } = res;
        if (state === 'executing') {
          history.push(completedRoutes.taskFinish(taskId), { solutionId, taskId });
        } else {
          changeErrorPopupState({ type: 'solutionWasFinish', isOpen: true, error: {} });
        }
      })
      .catch((error) => {
        if (error.status === 401) {
          history.replace(completedRoutes.signUpModalItem, { currentUrl: completedRoutes.taskInfo(taskId), taskId });
        } else {
          changeErrorPopupState({ type: 'postSolution', isOpen: true, error });
        }
      });
  };

  const { placeId } = taskData;

  const handleClickCompany = () => {
    history.push(completedRoutes.taskOwnerInfo(placeId), { placeId });
  };

  const isShowSubmitButton = taskData.count !== 0 && !isSolutionsFetching;
  const taskPlaceData = userPlacesById[placeId];
  if (taskPlaceData === undefined) return null;

  const content = (
    <>
      <Container>
        <div className="full-task-container">
          <div>
            <div className="title-container">
              <span className="title">{taskData.name}</span>
              <span className="price rubble">{taskData.price}</span>
            </div>
          </div>
          <div>
            <div className="address" onClick={handleClickCompany}>
              <span className="company-name">{taskPlaceData.name}</span>
              <span className="address-text">{taskPlaceData.address}</span>
            </div>
            <div className="description">
              <div dangerouslySetInnerHTML={{ __html: taskData.description }} />
            </div>
            <div className="count">
              {`${t('companyTask.count')}: `}
              {isSolutionsFetching
                ? <CircularProgress color="inherit" size={isMobileDesign ? 14 : 20} />
                : taskData.count
              }
            </div>
            <div className="reward">
              {`${t('companyTask.reward')}: `}
              <span className="green rubble">{t('companyTask.price', { count: taskData.price })}</span>
            </div>
            <ScoreToRubblesInfo />
          </div>
          <div className="rules-info">
            <Trans i18nKey="companyTask.rulesInfo">
              %<strong/><Link to={completedRoutes.userRules}/>%
            </Trans>
          </div>
          {isShowSubmitButton && !isMobileDesign && (
            <div>
              <YellowButton hidden={false} title={t('common.do')} handleClick={handleDo} />
            </div>
          )}
        </div>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      </Container>
      {isShowSubmitButton && isMobileDesign && <BottomButton title={t('common.do')} handleClick={handleDo}/>}
    </>
  );

  return (
    <ModalItem>
      <>
        <Hidden mdUp>
          {content}
        </Hidden>
        <ContentSwitch desktopOption={!isMobileDesign} content={content} taskId={taskId}/>
      </>
    </ModalItem>
  );
}

const mapStateToProps = state => ({
  tasksById: state.tasks.data.byId,
  userPlacesById: state.places.userPlaces.byId,
  isSolutionsFetching: state.tasks.solutionCountFetchingState === 'requesting',
  isTasksFetched: state.tasks.fetchingState === 'success',
});

const actionCreators = {
  changeErrorPopupState: changeErrorPopupState,
  postSolution: postSolution,
  getTaskSolutionsCountById: tasksActions.getTaskSolutionsCountById,
};

export default connect(mapStateToProps, actionCreators)(TaskInfo);
